import { createAction } from "@reduxjs/toolkit";
import {
    // Types
    ALL_PROPOSED_REGULATION_RECEIVED,
    ALL_RESTRICTIONS_RECEIVED,
    CHECK_LINK_HAS_PROPOSED_REGULATION,
    CHECK_REGULATION_HAS_PROPOSED_REGULATION,
    COPY_REGULATION_TO_PROPOSED,
    DELETE_PROPOSED_REGULATION,
    DELETE_PROPOSED_RESTRICTION,
    GET_ALL_PROPOSED_REGULATIONS_BY_ID,
    GET_ALL_RESTRICTIONS_FOR_GIVEN_REGULATION_IDS,
    GET_ALL_RESTRICTIONS,
    GET_PROPOSED_REGULATION_LINKS,
    GET_PROPOSED_REGULATION,
    GET_PROPOSED_RESTRICTION,
    GET_REGULATION_LINKS,
    GET_REGULATION_SECTION,
    POST_PROPOSED_RESTRICTION,
    PROPOSED_REGULATION_DELETED,
    PROPOSED_REGULATION_RECEIVED,
    PROPOSED_REGULATION_UPDATED,
    PROPOSED_RESTRICTION_DELETED,
    PROPOSED_RESTRICTION_RECEIVED,
    PROPOSED_RESTRICTION_UPDATED,
    RECEIVED_CHECK_REGULATION_HAS_PROPOSED_REGULATION,
    REGULATION_LINKS_RECEIVED,
    REGULATION_SECTION_RECEIVED,
    REGULATION_TO_PROPOSED_POSTED,
    TOGGLE_CREATE_OR_EDIT_ACTION_PERFORMED,
    TOGGLE_EDIT_OPTIONS_PANEL,
    TOGGLE_EDIT_REGULATION_PANEL,
    UPDATE_FILTERED_LINKS,
    UPDATE_FILTERED_PROPOSED_LINKS,
    UPDATE_PROPOSED_REGUATION,
    UPDATE_PROPOSED_RESTRICTION,
    AllProposedRegulationReceivedAction,
    AllRestrictionsReceivedAction,
    CheckLinkHasProposedRegulation,
    CheckRegulationHasProposedRegulation,
    CopyRegulationToProposedAction,
    DeleteProposedRegulationAction,
    DeleteProposedRestrictionAction,
    GetAllProposedRegulationsByIdAction,
    GetAllRestrictionsAction,
    GetAllRestrictionsForGivenRegulationIdsAction,
    GetProposedRegulationAction,
    GetProposedRegulationLinksAction,
    GetProposedRestrictionAction,
    GetRegulationLinksAction,
    GetRegulationSectionAction,
    PostProposedRestrictionAction,
    ProposedRegulationDeletedAction,
    ProposedRegulationReceivedAction,
    ProposedRegulationUpdatedAction,
    ProposedRestrictionDeletedAction,
    ProposedRestrictionReceivedAction,
    ProposedRestrictionUpdatedAction,
    RegulationLinksReceivedAction,
    RegulationSectionReceivedAction,
    RegulationToProposedPostedAction,
    ToggleEditOptionsPanelAction,
    toggleEditRegulationPanelAction,
    UpdateFilteredLinksAction,
    UpdateFilteredProposedLinksAction,
    UpdateProposedRegulationAction,
    UpdateProposedRestrictionAction,
    updateZoneAction,
    UPDATE_ZONE_ACTION,
    REGULATION_AND_RATES_FOR_SCENARIO_RECEIVED,
    RegulationsAndRatesForScenarioReceivedAction,
    GET_REGULATIONS_AND_RATES_FOR_SCENARIO,
    GetRegulationsAndRatesForScenarioAction
} from "./types";

export const updateFilteredLinks =
    createAction<UpdateFilteredLinksAction["payload"]>(UPDATE_FILTERED_LINKS);

export const updateFilteredProposedLinks = createAction<
    UpdateFilteredProposedLinksAction["payload"]
>(UPDATE_FILTERED_PROPOSED_LINKS);

export const getRegulationSection =
    createAction<GetRegulationSectionAction["payload"]>(GET_REGULATION_SECTION);

export const regulationSectionReceived = createAction<RegulationSectionReceivedAction["payload"]>(
    REGULATION_SECTION_RECEIVED
);

export const toggleEditRegulationPanel = createAction<toggleEditRegulationPanelAction["payload"]>(
    TOGGLE_EDIT_REGULATION_PANEL
);

export const toggleEditOptionsPanel =
    createAction<ToggleEditOptionsPanelAction["payload"]>(TOGGLE_EDIT_OPTIONS_PANEL);

export const getRegulationsAndRatesForScenario = createAction<
    GetRegulationsAndRatesForScenarioAction["payload"]
>(GET_REGULATIONS_AND_RATES_FOR_SCENARIO);

export const regulationsAndRatesForScenarioReceived = createAction<
    RegulationsAndRatesForScenarioReceivedAction["payload"]
>(REGULATION_AND_RATES_FOR_SCENARIO_RECEIVED);

export const getAllRestrictionsForGivenRegulationIds = createAction<
    GetAllRestrictionsForGivenRegulationIdsAction["payload"]
>(GET_ALL_RESTRICTIONS_FOR_GIVEN_REGULATION_IDS);

export const allRestrictionsReceived =
    createAction<AllRestrictionsReceivedAction["payload"]>(ALL_RESTRICTIONS_RECEIVED);

export const copyRegulationToPropsed = createAction<CopyRegulationToProposedAction["payload"]>(
    COPY_REGULATION_TO_PROPOSED
);

export const regulationToPropsedPosted = createAction<RegulationToProposedPostedAction["payload"]>(
    REGULATION_TO_PROPOSED_POSTED
);

// Proposed Regulation

export const getProposedRegulation =
    createAction<GetProposedRegulationAction["payload"]>(GET_PROPOSED_REGULATION);

export const proposedRegulationReceived = createAction<ProposedRegulationReceivedAction["payload"]>(
    PROPOSED_REGULATION_RECEIVED
);

export const allProposedRegulationReceived = createAction<
    AllProposedRegulationReceivedAction["payload"]
>(ALL_PROPOSED_REGULATION_RECEIVED);

export const getAllProposedChangesById = createAction<
    GetAllProposedRegulationsByIdAction["payload"]
>(GET_ALL_PROPOSED_REGULATIONS_BY_ID);

export const updateProposedRegulation =
    createAction<UpdateProposedRegulationAction["payload"]>(UPDATE_PROPOSED_REGUATION);

export const updateZone = createAction<updateZoneAction["payload"]>(UPDATE_ZONE_ACTION);

export const proposedRegulationUpdated = createAction<ProposedRegulationUpdatedAction["payload"]>(
    PROPOSED_REGULATION_UPDATED
);

export const deleteProposedRegulation = createAction<DeleteProposedRegulationAction["payload"]>(
    DELETE_PROPOSED_REGULATION
);

export const proposedRegulationDeleted = createAction<ProposedRegulationDeletedAction["payload"]>(
    PROPOSED_REGULATION_DELETED
);

// Proposed Restriction

export const getProposedRestriction =
    createAction<GetProposedRestrictionAction["payload"]>(GET_PROPOSED_RESTRICTION);

export const proposedRestrictionReceived = createAction<
    ProposedRestrictionReceivedAction["payload"]
>(PROPOSED_RESTRICTION_RECEIVED);

export const updateProposedRestriction = createAction<UpdateProposedRestrictionAction["payload"]>(
    UPDATE_PROPOSED_RESTRICTION
);

export const proposedRestrictionUpdated = createAction<ProposedRestrictionUpdatedAction["payload"]>(
    PROPOSED_RESTRICTION_UPDATED
);

export const deleteProposedRestriction = createAction<DeleteProposedRestrictionAction["payload"]>(
    DELETE_PROPOSED_RESTRICTION
);

export const proposedRestrictionDeleted = createAction<ProposedRestrictionDeletedAction["payload"]>(
    PROPOSED_RESTRICTION_DELETED
);

export const postProposedRestriction =
    createAction<PostProposedRestrictionAction["payload"]>(POST_PROPOSED_RESTRICTION);

// Regulation Links

export const getRegulationLinks =
    createAction<GetRegulationLinksAction["payload"]>(GET_REGULATION_LINKS);

// Proposed Regulation Links

export const getProposedRegulationLinks = createAction<GetProposedRegulationLinksAction["payload"]>(
    GET_PROPOSED_REGULATION_LINKS
);

export const regulationLinksReceived =
    createAction<RegulationLinksReceivedAction["payload"]>(REGULATION_LINKS_RECEIVED);

export const checkLinkHasProposedRegulation = createAction<
    CheckLinkHasProposedRegulation["payload"]
>(CHECK_LINK_HAS_PROPOSED_REGULATION);

export const checkRegulationHasProposedRegulation = createAction<
    CheckRegulationHasProposedRegulation["payload"]
>(CHECK_REGULATION_HAS_PROPOSED_REGULATION);

export const receivedCheckRegulationHasProposedRegulationReceived = createAction(
    RECEIVED_CHECK_REGULATION_HAS_PROPOSED_REGULATION
);

export const toggleCreateorEditActionPerformed = createAction(
    TOGGLE_CREATE_OR_EDIT_ACTION_PERFORMED
);
